module.exports = __webpack_public_path__ + "static/media/crofts.ee3eeb76.jpg";